import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPChangelogDatasource } from '../datasources/ap_changelog_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadChangelogCommand',
    function loadChangelogCommand(
      defineCommandORM: IDefineCommand,
      ngAPChangelogDatasource: IAPChangelogDatasource,
      $http: ng.IHttpService
    ) {
      return defineCommandORM('loadChangelogCommand', (deferred: any) => {
        $http
          .get(`/academicplan/suggested_plan/history/`)
          .then((response: any) => {
            ngAPChangelogDatasource.write(response.data);
            deferred.resolve();
          })
          .catch((e: any) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/changelog/commands/load_changelog_command.ts